import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/jobs")({
  component: () => (
    <Breadcrumb label="Jobs" to="/jobs">
      <Outlet />
    </Breadcrumb>
  ),
});
